// The backend hands the session two exit destinations — `completeUrl` (session
// finished) and `exitUrl` ("Complete later") — usually pointing back at the
// app that launched the exercise. Both are optional: when neither arrives the
// caller falls back to the post-performance page.

/**
 * Validates a backend-provided redirect target. Returns an absolute href, or
 * null when the value is missing/blank or not an http(s) URL — a socket
 * payload must never be able to hand us a `javascript:` or `data:` target.
 */
export function normalizeRedirectUrl(rawUrl) {
  if (typeof rawUrl !== 'string' || !rawUrl.trim()) {
    return null;
  }

  try {
    const parsed = new URL(rawUrl.trim(), window.location.origin);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    return parsed.href;
  } catch (_error) {
    return null;
  }
}

/**
 * Leaves the exercise: to `url` when the backend supplied a usable one,
 * otherwise to /post-performance. `replace` is used so the finished session
 * isn't left sitting in history for the back button to return to.
 */
export function leaveSession({ url, navigate }) {
  const target = normalizeRedirectUrl(url);

  if (target) {
    window.location.replace(target);
    return true;
  }

  navigate?.('/post-performance', { replace: true });
  return false;
}
